var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "#FECB90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C9.44772 15 9 14.5523 9 14V6C9 5.44772 9.44772 5 10 5V5C10.5523 5 11 5.44772 11 6V14C11 14.5523 10.5523 15 10 15V15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C5 9.44772 5.44772 9 6 9H14C14.5523 9 15 9.44772 15 10V10C15 10.5523 14.5523 11 14 11H6C5.44772 11 5 10.5523 5 10V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInfoIcon);
export default __webpack_public_path__ + "static/media/open-info-icon.b2a99ce1593bb589267f0989df49aad5.svg";
export { ForwardRef as ReactComponent };